import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { DespesaService } from '../services/despesa.service';
import { ProfissionalService } from '../services/profissional.service';
import { FornecedorService } from '../services/fornecedor.service';
import { VeiculoService } from '../services/veiculo.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';

@Component({
	selector: 'app-ipva-edit',
	templateUrl: './ipva-edit.component.html',
	styleUrls: ['./ipva-edit.component.css'],
	animations: [loadingFade]
})
export class IpvaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public despesa_id = null;

	public unidades = [];
	public cliente = [];

	public formDespesa: FormGroup;
	public tipo_despesa_array = [];
	public veiculo_array: NgOption[] = [];
	public fornecedor_array = [];
	public unidade_medida_array = [];
	public despesa_solicitante_array = []

	public qtde_char_descricao = 0;

	// datepickers
	private data_compra_dp;

	//filtro
	public despesa_data_compra___data_i = null;
	public despesa_data_compra___data_f = null;
	public veiculo_id___veiculo_id = null;
	public cliente_id___cliente_id = null;
	public unidade_id___unidade_id = null;
	public despesa_situacao__despesa_situacao = null;


	constructor(private authSvc: AuthService,
				private route: ActivatedRoute,
				private fb: FormBuilder,
				private despesaSvc: DespesaService,
				private fornecedorSvc: FornecedorService,
				private router: Router,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private veiculoSvc: VeiculoService) { }

	ngOnInit() {
		this.criaForm();
		this.pegaClientes();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {


				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "cliente_id___cliente_id": { 
						 this.cliente_id___cliente_id = loSplitValor[1];
						 break; 
					  } 
					  case "unidade_id___unidade_id": { 
						this.unidade_id___unidade_id = loSplitValor[1];
						 break; 
					  } 
					  case "veiculo_id___veiculo_id": { 
						this.veiculo_id___veiculo_id = loSplitValor[1];
						 break; 
					  } 
					  case "despesa_data_compra___data_i": { 
						this.despesa_data_compra___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "despesa_data_compra___data_f": { 
						this.despesa_data_compra___data_f = loSplitValor[1];
						 break; 
					  }      
					  case "despesa_situacao__despesa_situacao": { 
						this.despesa_situacao__despesa_situacao = loSplitValor[1];
						 break; 
					  }                                                        
				   }
		
				  }
		
		
				}

				this.despesa_id = params.id;
				// pega dados a partir do id
				this.despesaSvc.getDespesa(params.id).then((data: any) => {
					let data_compra = null
					this.pegaUnidades(data.cliente_id)
					this.getSolicitantes(data.cliente_id)					

					if (moment(data.despesa_data_compra).isValid()) {
						let moment_date = moment(data.despesa_data_compra, 'YYYY-MM-DD');
						data_compra = moment_date.format('DD/MM/YYYY');
						this.data_compra_dp.setDate(moment_date.toDate());
					}

					this.preencheForm({
						despesa_id: data.despesa_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						veiculo_id: data.veiculo_id,
						despesa_valor: data.despesa_valor,
						despesa_data_compra: data_compra,
						despesa_descricao: data.despesa_descricao,
						despesa_situacao: data.despesa_situacao,
						despesa_solicitante: data.despesa_solicitante,
						despesa_aprovador: data.despesa_aprovador,
						despesa_valor_licenciamento: data.despesa_valor_licenciamento,
						despesa_valor_seguro: data.despesa_valor_seguro,
						despesa_solicitante_id: data.despesa_solicitante_id
					});

					if (data.despesa_descricao)
						this.qtde_char_descricao = data.despesa_descricao.length;

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formDespesa = this.fb.group({
			despesa_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			veiculo_id: [null, Validators.required],
			despesa_valor: ['', Validators.required],
			despesa_data_compra: [null, Validators.required],
			despesa_descricao: ['', Validators.maxLength(200)],
			despesa_situacao: [null, Validators.required],
			despesa_solicitante: ['', Validators.maxLength(100)],
			despesa_aprovador: null,
			despesa_valor_licenciamento: ['', Validators.required],
			despesa_valor_seguro: ['', Validators.required],
			despesa_solicitante_id: ''
		});

		this.pegaVeiculos();
		//this.pegaFornecedores();

		moment.locale('pt-Br');
		this.data_compra_dp = Datepicker('#despesa_data_compra', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formDespesa.controls['despesa_data_compra'].setValue(formatted);
			}
		});
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: veiculo.unidade_id,
					cliente_id: veiculo.cliente_id,
				});
			}
			this.veiculo_array = dados;
		}).catch((err) => {
			console.log(err)
		});
	}

	pegaFornecedores() {
		this.fornecedorSvc.getFornecedores('fornecedor_nome').then((data: any[]) => {
			this.fornecedor_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formDespesa.setValue(dados);
	}

	onChangeVeiculo(e) {
		this.formDespesa.controls['unidade_id'].setValue(e.unidade_id);
		this.formDespesa.controls['cliente_id'].setValue(e.cliente_id);
	}

	enviaDespesa() {
		if (this.formDespesa.valid) {
			this.submitting = true;

			let toSend = this.formDespesa.value;
			toSend['grupo_despesa_id'] = 3;
			toSend['fornecedor_id'] = 1;
			console.log('toSend', toSend)
			if (this.despesa_id === null) { // criar
				this.despesaSvc.criaIpva(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Despesa cadastrada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/ipva']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.despesaSvc.editaIpva(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Despesa alterada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/ipva']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formDespesa.controls){
				let campo = this.formDespesa.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.cliente = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }	

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formDespesa.value.despesa_descricao.length;
	}

	invalid(nome) {
		let input = this.formDespesa.get(nome);
		return input.touched && input.invalid;
	}

	
	onChangeClientes(e){
		this.formDespesa.controls.unidade_id.setValue(null);
		this.formDespesa.controls.veiculo_id.setValue(null);
		this.formDespesa.controls.despesa_solicitante_id.setValue(null);

		this.getSolicitantes(e.cliente_id);

		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  onChangeVeiculoUnidade(e){
		this.veiculo_array = []
		this.veiculoSvc.getByVeiculoClienteUnidade(e.unidade_id,e.cliente_id).then((data: any[]) => {

			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: e.unidade_id,
					cliente_id: e.cliente_id
				});
			}

			this.veiculo_array = dados;


			  }).catch((err) => {
				  console.log(err);
			  });
	  }

	  getSolicitantes(cliente){

		this.clienteSvc.getSolicitanteClientesByUsuario(cliente).then((data: any) => {

		  let dados = [];
		  for(let solicitante of data){
			  dados.push({
				  despesa_solicitante_id: solicitante.usuario_id,
				  despesa_solicitante_nome: solicitante.usuario_nome
			  });
		  }
		  this.despesa_solicitante_array = dados;

		}).catch((err) => {
		  console.log(err);
		});
	  }
	  
	  pegaUnidades(cliente_id){
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  onClickVoltar(){

		let params = 'cliente_id___cliente_id=' + this.cliente_id___cliente_id;
		params += "&unidade_id___unidade_id=" + this.unidade_id___unidade_id;
		params += "&veiculo_id___veiculo_id=" + this.veiculo_id___veiculo_id;
		params += "&despesa_data_compra___data_i=" + this.despesa_data_compra___data_i;
		params += "&despesa_data_compra___data_f=" + this.despesa_data_compra___data_f;
		params += "&despesa_situacao__despesa_situacao=" + this.despesa_situacao__despesa_situacao;
	
		this.router.navigate(['/home/ipvafiltro/' + params]);
	
	  }

}
